import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "body" }
const _hoisted_2 = {
  key: 0,
  class: "popup-loader"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "table table-borderless"
}
const _hoisted_5 = {
  key: 0,
  class: "InputTitle"
}
const _hoisted_6 = {
  key: 1,
  class: "InputTitle"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  for: "tbox1",
  style: {"padding-bottom":"6px","font-size":"14px","margin-right":"18rem","font-weight":"bold"}
}
const _hoisted_10 = { class: "report-radio-group" }
const _hoisted_11 = { class: "costElement" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  for: "tbox1",
  style: {"padding-bottom":"6px","font-size":"14px","font-weight":"bold"}
}
const _hoisted_14 = { class: "reportFormat-radio-group" }
const _hoisted_15 = { class: "popup-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridLoading = _resolveComponent("GridLoading")!
  const _component_NumberOfInput = _resolveComponent("NumberOfInput")!
  const _component_kbutton = _resolveComponent("kbutton")!
  const _component_dialog_actions_bar = _resolveComponent("dialog-actions-bar")!
  const _component_k_dialog = _resolveComponent("k-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_k_dialog, {
      title: _ctx.$t('operationListComp.downloadReport'),
      onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('close'))),
      class: "reportPopup",
      width: "600"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.loadingGrid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_GridLoading, {
                  infoText: _ctx.$t('operationListComp.reportCompilationNotification')
                }, null, 8, ["infoText"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    (_ctx.showQuantity || _ctx.showProdLines)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              (_ctx.showQuantity)
                                ? (_openBlock(), _createElementBlock("th", _hoisted_5, _toDisplayString(_ctx.noOfGarmentsText), 1))
                                : _createCommentVNode("", true),
                              (_ctx.showProdLines)
                                ? (_openBlock(), _createElementBlock("th", _hoisted_6, _toDisplayString(_ctx.noOfProductLineText), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("tr", null, [
                              (_ctx.showQuantity)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: _normalizeClass(["numberInput", { errorStyle: _ctx.errorMsgGarment }]),
                                      type: "text",
                                      inputmode: "numeric",
                                      pattern: "[0-9]*",
                                      id: "tbox1",
                                      name: "tbox1",
                                      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.validateGarmentValue($event.target))),
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.noOfGarmentsVal) = $event))
                                    }, null, 34), [
                                      [_vModelText, _ctx.noOfGarmentsVal]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.showProdLines)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                                    _createVNode(_component_NumberOfInput, {
                                      class: "noOfProductionLines",
                                      onOnChangeVal: _ctx.validateProductionLineValue,
                                      error: _ctx.errorMsgProductLine,
                                      Value: _ctx.noOfProductLineVal
                                    }, null, 8, ["onOnChangeVal", "error", "Value"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("operationListComp.chooseReport")), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        value: "sgc",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedReport) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.selectedReport]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("operationListComp.singleGarmentConsumption")), 1)
                    ]),
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        value: "sgcWithQuantity",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedReport) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.selectedReport]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("operationListComp.singleGarmentConsumptionWithQuantity")), 1)
                    ]),
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        value: "tu",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedReport) = $event))
                      }, null, 512), [
                        [_vModelRadio, _ctx.selectedReport]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("operationListComp.threadUsageReport")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", {
                      class: _normalizeClass({ checkedAndDisabled: _ctx.disableCostElement })
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isChecked) = $event)),
                        disabled: _ctx.disableCostElement
                      }, null, 8, _hoisted_12), [
                        [_vModelCheckbox, _ctx.isChecked]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("operationListComp.includeCostElement")), 1)
                    ], 2)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("operationListComp.chooseReportType")), 1),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          value: "pdf",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedReportFormat) = $event))
                        }, null, 512), [
                          [_vModelRadio, _ctx.selectedReportFormat]
                        ]),
                        _cache[10] || (_cache[10] = _createTextVNode(" PDF ", -1)),
                        _cache[11] || (_cache[11] = _createElementVNode("span", {
                          class: "far fa-file-pdf",
                          style: {"padding-right":"5px"}
                        }, null, -1))
                      ]),
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          value: "csv",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedReportFormat) = $event))
                        }, null, 512), [
                          [_vModelRadio, _ctx.selectedReportFormat]
                        ]),
                        _cache[12] || (_cache[12] = _createTextVNode(" CSV ", -1)),
                        _cache[13] || (_cache[13] = _createElementVNode("span", {
                          class: "fas fa-file-csv",
                          style: {"padding-right":"5px"}
                        }, null, -1))
                      ])
                    ])
                  ])
                ]),
                _createVNode(_component_dialog_actions_bar, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_kbutton, {
                        class: "cancel",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
                      }, {
                        default: _withCtx(() => [
                          _cache[14] || (_cache[14] = _createElementVNode("i", {
                            class: "fas fa-xmark",
                            style: {"padding-right":"5px","font-weight":"bold"}
                          }, null, -1)),
                          _createTextVNode(_toDisplayString(_ctx.$t("operationListComp.close")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_kbutton, {
                        class: "btn-primary save",
                        onClick: _ctx.handleReportDownload
                      }, {
                        default: _withCtx(() => [
                          _cache[15] || (_cache[15] = _createElementVNode("i", {
                            class: "fas fa-download",
                            style: {"padding-right":"5px"}
                          }, null, -1)),
                          _createTextVNode(_toDisplayString(_ctx.$t("operationListComp.download")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                })
              ]))
        ])
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}